import { render } from "./SymboliekView.vue?vue&type=template&id=267d8efb"
import script from "./SymboliekView.vue?vue&type=script&lang=js"
export * from "./SymboliekView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__